import { render, staticRenderFns } from "./TheContentFooter.vue?vue&type=template&id=8ba5e910&"
import script from "./TheContentFooter.vue?vue&type=script&lang=js&"
export * from "./TheContentFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports